module.exports = __webpack_public_path__ + "media/bg-dm.5eb2a2bd.mp3";